module.exports = __webpack_public_path__ + "static/toodledo_configure-634c636e3099a2455503ff54be6b4238.png";